import styled from 'styled-components'

import { Title as TitleUI, DescriptionText } from '../styles'

export const Title = styled(TitleUI)`
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
`

export const Wrapper = styled.section`
  margin-bottom: 90px;

  ${({ theme }) => theme.below.laptop`
    margin-bottom: 50px;
    padding: 0 ${theme.spaces[3]}px;
  `}

  .orange-link {
    font-size: inherit;
  }
`

export const Description = styled(DescriptionText)`
  margin-bottom: 50px;

  ${({ theme }) => theme.below.laptop`
    margin-bottom: ${theme.spaces[3]}px;
  `}
`
